export default __webpack_public_path__ + "static/media/16.08e49e57.jpg";